{
  "journalAudit.action.document.production_requested": "Production d’un document demandée",
  "journalAudit.action.process.gate_approved": "Voix d’acceptation d’une porte de phase enregistrée"
}
